var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card-body prelative flex-column ai-center jc-center" },
    [
      _c(
        "div",
        { staticClass: "div-block flex-column ov-hidden ai-center jc-center" },
        [
          _c("img", {
            attrs: { src: _vm.placeholderImg, alt: "", width: "120" }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "acenter gray-80 fs-4 bold" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$l10n.__("Un problème est survenu")) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _vm._t("placeholder", [
            _c("p", { staticClass: "dinlineb gray-60 acenter fs-3" }, [
              _vm._v(_vm._s(_vm.placeHolderText))
            ])
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }